let viewArr = networkList;
let warehouseList = [];
let truckList = [];
let etcList = [];
let viewAmount = 6; //한번에 노출되는 리스트 수
let pageNumMax = 5; //Paination 노출 수
const $locationDomesticNetworksStatus = $('.location_domestic-networks-status');
const $networkList = $('.domestic-networks-list-table .list');
const $networkCategory = $('.domestic-networks-list-table .category');
const $lxPagination = $('.lx_pagination');
const $lxPaginationButtons = $('.lx_pagination .page');

let gfn_lang = $('html').attr('lang');
let warehouse = gfn_lang != 'en' ? '물류센터' : 'ct_warehouse';
let transport = gfn_lang != 'en' ? '운송센터' : 'ct_transport';
let etc = gfn_lang != 'en' ? '타 사업부' : 'ct_etc';

console.log(transport, warehouse, etc);

const network = {
    init: function () {
        //카테고리별로 배열 생성
        this.makeArr(warehouse, warehouseList);
        this.makeArr(transport, truckList);
        this.makeArr(etc, etcList);

        //최초 리스트, pagination 세팅
        this.set();

        //지도에 카테고리별 레이어 append
        $locationDomesticNetworksStatus.children('li').each(function () {
            let name = $(this).children('button').text();

            $(this).children('div').remove();
            $(this).append(`
            <div>
                <strong class="name">${name}</strong>
                <ul class="domestic-networks-status">
                    <li class="warehouse">${network.count(name, warehouse)}</li>
                    <li class="truck">${network.count(name, transport)}</li>
                    <li class="office">${network.count(name, etc)}</li>
                </ul>
                <button type="button" class="btn-close-layered"><span>닫기</span></button>
            </div>
            `);
        });
    },
    //최초, 카테고리 변경 시 SET
    set: function () {
        this.selectCategory(); //카테고리변경 및 pagination 생성
        this.makeList(0); //첫번째 리스트 생성
        this.showPageButton(0); //첫번째 pagination 그룹 show
    },
    //Pagination을 통한 변경
    change: function (idx) {
        this.makeList(idx);
        this.showPageButton(idx);
    },
    //카테고리별 배열 생성
    makeArr: function (category, arr) {
        let count = 0;
        $.each(networkList, function (i) {
            if (this.category == category) {
                arr[count] = this;
                arr[count].index = count;
                count++;
            }
        });
    },
    //카테고리 선택 시 배열 교체 + Pagination 버튼 생성
    selectCategory: function () {
        //초기화
        $locationDomesticNetworksStatus.removeClass(
            'only-warehouse only-truck only-office',
        );
        let category = $networkCategory.find('.is-active').data('category');
        if (category == 'all') {
            viewArr = networkList;
        } else if (category == 'warehouse') {
            viewArr = warehouseList;
            $locationDomesticNetworksStatus.addClass('only-warehouse');
        } else if (category == 'truck') {
            viewArr = truckList;
            $locationDomesticNetworksStatus.addClass('only-truck');
        } else if (category == 'etc') {
            viewArr = etcList;
            $locationDomesticNetworksStatus.addClass('only-office');
        }
        this.createPageButton(viewArr);
    },
    //Pagination 버튼 생성
    createPageButton: function (arr) {
        $lxPaginationButtons.empty();
        let totalPage;
        $.each(arr, function (i) {
            let html = '';
            totalPage = Math.ceil(arr.length / viewAmount);
            for (let i = 1; i <= totalPage; i++) {
                html += `<a href="javascript:;" data-page=${i}>${i}</a>`;
            }
            $lxPaginationButtons.html(html);
        });
        $lxPagination.attr('data-max', totalPage);
    },
    //노출, 비노출 버튼 체크
    showPageButton: function (selectNum) {
        let totalPage = $lxPagination.data('max');
        let startGroup = Math.floor(selectNum / pageNumMax);
        let min = startGroup * pageNumMax;
        let max =
            min + (pageNumMax - 1) > totalPage
                ? totalPage
                : min + (pageNumMax - 1);

        //console.log(min + '부터' + max + '까지 보여줌', '현재상태' + selectNum);

        $lxPaginationButtons.find('a').removeClass('hidden');
        $lxPaginationButtons.find('a:lt(' + min + ')').addClass('hidden');
        $lxPaginationButtons.find('a:gt(' + max + ')').addClass('hidden');
        $lxPaginationButtons
            .find('a:eq(' + selectNum + ')')
            .addClass('is-current')
            .siblings('a')
            .removeClass('is-current');

        $lxPagination.children('a').removeClass('is-disabled');
        if (!$lxPaginationButtons.find('a:eq(' + max + ')').next('a').length)
            $lxPagination.find('.btn-next').addClass('is-disabled');

        if (!$lxPaginationButtons.find('a:eq(' + min + ')').prev('a').length)
            $lxPagination.find('.btn-prev').addClass('is-disabled');
    },
    makeList: function (pageIdx) {
        //reset
        $networkList.empty();
        let count = 0;
        $.each(viewArr, function (i) {
            if (i >= pageIdx * viewAmount && count < viewAmount) {
                info = `
                <li>
                    <i class="lx_icon-wnd-pin-grey-20"></i>
                    <strong class="name">${this.name}</strong>
                    ${
                        this.goods
                            ? `<span class="goods">${this.goods}</span>`
                            : ''
                    }
                    <p class="address">${this.address}</p>
                </li>
                `;
                $networkList.append(info);
                count++;
            }
        });
    },
    //지역별, 카테고리별 갯수 세기
    count: function (area, category) {
        let countArr = networkList.filter(
            (item) => item.area == area && item.category == category,
        );
        return countArr.length;
    },
};

network.init();

//지도 위 버튼
$locationDomesticNetworksStatus.on('click', 'button', function () {
    if ($(this).parent('li').length) {
        $(this)
            .parent('li')
            .addClass('is-active')
            .siblings('li')
            .removeClass('is-active');
    } else {
        $(this).parents('li').removeClass('is-active');
    }
});

//TAB (카테고리 선택 - 지도 반영분)
$networkCategory.on('click', 'button', function () {
    $(this).addClass('is-active').siblings('button').removeClass('is-active');
    network.set();
});

$(document).on('click', '.lx_pagination a:not(".is-disabled")', function () {
    let totalPage = $lxPagination.data('max');
    let idx = $(this).index();
    let currentIdx = $('.lx_pagination a.is-current').index();
    let currentGroup = Math.floor(currentIdx / pageNumMax);

    let min = currentGroup - 1 < 0 ? 0 : (currentGroup - 1) * pageNumMax;
    let max =
        (currentGroup + 1) * pageNumMax > totalPage
            ? totalPage
            : (currentGroup + 1) * pageNumMax;

    if ($(this).hasClass('btn-prev')) {
        network.change(min);
    } else if ($(this).hasClass('btn-next')) {
        network.change(max);
    } else {
        network.change(idx);
    }
});
